module.exports = __webpack_public_path__ + "img/phone.ebbfd0dc.png";